export const StyleConstants = {
  playerButtonHex: '77B4B3',
  pwaBackgroundColor: 'black',
  pwaThemeColor: 'black',
};
